import { render, staticRenderFns } from "./import-vehicle.vue?vue&type=template&id=b65e8610&scoped=true&"
import script from "./import-vehicle.vue?vue&type=script&lang=js&"
export * from "./import-vehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65e8610",
  null
  
)

export default component.exports